import CaptainTrainingUrlAPI from 'dashboard/api/captain/trainingUrl';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'CaptainTrainingUrl',
  API: CaptainTrainingUrlAPI,
});
